import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CardAction } from '@/common/components/CardAction/CardAction';
import { Icon } from '@/common/components/Icons/Icon';
import { IllustrationDesktop } from '@/common/components/Illustrations/IllustrationDesktop';
import { ESWalletLearningCentre } from '@/common/containers/Dashboard/Home/ESHomePage/ESWalletLearningCentre/ESWalletLearningCentre';
import { useGetOperations } from '@/common/integrations/menhir/employee/operations/operations.hooks';

export function ESGettingStartedCard() {
  const { t } = useTranslation();
  const { operations, isInitialLoading } = useGetOperations({
    filters: {
      type: 'benefit_expense',
    },
    perPage: 1,
  });
  const [showModal, setShowModal] = useState(false);

  if (isInitialLoading || operations?.list.length) {
    return null;
  }

  return (
    <>
      <CardAction
        title={t('dashboard.home.es.wallet.getting_started.title')}
        description={t('dashboard.home.es.wallet.getting_started.description')}
        illustration={{
          asset: <IllustrationDesktop width={112} height={80} />,
        }}
        backgroundColor="accentSecondary20"
        action={<Icon icon="chevron-right" />}
        size="md"
        onPress={() => setShowModal(true)}
      />
      {showModal && (
        <ESWalletLearningCentre onClose={() => setShowModal(false)} />
      )}
    </>
  );
}
